import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {
    deepCopyObject,
    checkUseTmpUpdateQuery,
    showAxiosError,
    checkUseTmpUpdateQueryWithDespatch
} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from 'react-s-alert';
import '../../local_node_modules/react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import NumberFormat from "react-number-format";
import {Decimal} from "decimal.js";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import moment from "moment";
import ReactLoading from "react-loading";
import axios from "axios";
import {isValidERPOutboxPyld} from "../../common/componentValidation";
import {modifyDespatch, modifyInvoice, modifyVoucher, uuidGenerator} from "./erpHelper";
import {UncontrolledTooltip} from "reactstrap";
import {showConnectorPayment} from "../../helper/permission";
import {EntegratorConf} from "../../constants";

class GetFromConnectorModalWs extends Component {

    constructor(props) {
        super(props);
        this.state ={
            outboxList:[],
            searchQuery:undefined,
            totalLength:null,
            loopSize:null,
            loopIndex:0,
            connected:false,
            saveClicked:false,
            continueSend:false,
            retry:false,
            retryCount:0,
            Date: null
        };
    }

    componentDidMount() {
        let {connectionInfo} = this.props;
        this.listenWebSocket(connectionInfo.ownerIp);
    }


    setCron = () => {
        let self = this;
        const interval = setInterval(() => {
            console.log("interval::", interval);
            console.log("self.state.retryCount::", self.state.retryCount);
            console.log("self.state.retry::", self.state.retry);
            console.log("self.state.outboxList.length::", self.state.outboxList.length);
            if(self.state.retryCount === 7){
                self.setState({
                    continueSend:true,
                    retry: true,
                    retryCount: 0,
                    outboxList:[],
                    invoiceIndex:0
                }, () => self.documentInformation(self.state.searchQuery));
            }else{
                if (self.state.retry) {
                    self.setState({retryCount: self.state.retryCount + 1});
                } else {
                    self.setState({retryCount: 0});
                }
            }
        }, 5000);
        self.setState({interval});
    }

    getStatusRender = (status) => {
        let className;
        let color;
        switch(status) {
            case "processing":
                className = "spinner fa-spin";
                color = "dark"
                break;
            case "success":
                className = "check";
                color = "green";
                break;
            case "error":
                className = "close";
                color = "red";
                break;
            default:
                className = "pause";
                color = "dark";
        }
        return (<i className={"fas fa-" + className} style={{color:color,paddingRight:"4px"}}></i>);
    }

    onChange = (e,index) => {
        let outboxList = deepCopyObject(this.state.outboxList);
        outboxList[index][e.name]=
            ((e.name === "invoiceQuantity" && e.value !== "" ) ||
                (e.name === "unitPrice"  && e.value !== "") ||
                (e.name === "allowancePercent"  && e.value !== "") ||
                (e.name === "allowanceAmount"  && e.value !== "") ||
                (e.name === "kdvPercent"  && e.value !== "") ||
                (e.name === "kdvAmount"  && e.value !== "") ||
                (e.name === "lineExtensionAmount"  && e.value !== "")) ? (new Decimal(e.value)).toNumber() : e.value;
        this.setState({outboxList});
    }

    outboxFinal = () =>{
        let {outboxList} = this.state
        outboxList = deepCopyObject(outboxList);
        return(outboxList);
    }

    confirm = async (startCron) => {
        let self= this;
        this._source = axios.CancelToken.source();
        if(startCron){
            self.setCron();
        }
        let outboxList = self.outboxFinal();
        self.setState({saveClicked:true, continueSend:false});
        for(let index = 0;index < outboxList.length;index++){
            let outbox = outboxList[index];
            let result = isValidERPOutboxPyld(outbox, index);
            let valid = result.valid;
            if (valid) {
                await self.addDespatch(deepCopyObject(outbox));
            }else{
                outbox.error = result.errorMessage;
                outbox.status = "error";
                outboxList[index] = outbox;
                self.setState({outboxList,confirmBtnDisabled:false});
            }
        }
    }

    addDespatch = async (outbox) =>{
      let self = this;
      if (self.props.type==='invoice'){
        let params = {
          url: `/connector/readInvoicesDespatch/${outbox.referenceId}`,
          method: "post"
        };
        try {
          let req;
          if (outbox.despatchReferenceId===''||outbox.despatchReferenceId===null){
            req = await request(params);
          }
          if(req && req.data){
            self.send(req.data,"READ_INVOICE_DESPATCH",outbox.documentUuid);
          }else{
            await self.readInvoiceLineSql(deepCopyObject(outbox));
          }
        }catch(error){
          let err = {response:{data:"Kayıt Hatası"}}
          showAxiosError(err);
        }
      }else{
          await self.readInvoiceLineSql(deepCopyObject(outbox));
      }
  }

    readInvoiceLineSql = async (outbox)=> {
        let self = this;
        let {type}=self.props;
        let params = {
            url: `/connector/readInvoiceLineSql/${outbox.referenceId}/${type}`,
            method: "post"
        };
        try{
            let {data} = await request(params);
            if(data){
                self.send(data,"READ_DOCUMENT_LINE",outbox.documentUuid);
            }
        }catch(error){
            let err = {response:{data:"Kayıt Hatası"}}
            showAxiosError(err);
        }
    }

    readInvoiceLineChargeSql = async (lineReferenceId,referenceIdList,invoiceTypeCode,recordId)=> {
        let self = this;
        let {type}=self.props;
        let params = {
            url: `/connector/readInvoiceLineChargeSql/${type}`,
            method: "post",
            data:{
                lineReferenceId,
                referenceIdList,
                invoiceTypeCode
            }
        };
        try{
            let {data} = await request(params);
            self.send(data,"READ_DOCUMENT_LINE_CHARGE",recordId);

        }catch(error){
            let err = {response:{data:"Kayıt Hatası"}}
            showAxiosError(err);
        }
    }

    updateTmpInvoiceSql = async (document) => {
        let self = this;
        let params = {
            url: `/connector/updateTmpInvoiceSql/${document.referenceId}`,
            method: "post"
        };
        try{
            let {data} = await request(params);
            if(data){
                self.send(data,"UPDATE_TMP_INVOICE",document.referenceId);
            }
        }catch(error){
            console.log("err",error);
        }
    }

    updateTmpDespatchSql = async (document) => {
        let self = this;
        let params = {
            url: `/connector/updateTmpDespatchSql/${document.referenceId}`,
            method: "post"
        };
        try{
            let {data} = await request(params);
            if(data){
                self.send(data,"UPDATE_TMP_DESPATCH",document.referenceId);
            }
        }catch(error){
            console.log("err",error);
        }
    }

    documentInformation = async (searchQuery)=> {
        let self = this;
        let {type}=self.props;
        self.setState({searching:true, searchQuery, saveClicked:false});
        let params = {
            url: `/connector/documentInformationWs/${type}/&${searchQuery}`,
            method: "post"
        };
        try{
            let {data} = await request(params);
            let limit = data.limit ? data.limit:50;
            self.setState({limit});
            this.send(data.query,"INVOICE_LENGTH");
        }catch(error){
            let err = {response:{data:"Bağlantı Hatası"}}
            showAxiosError(error);
            self.setState({outboxList:[],searching:false});
        }
    }

    handleSearch = async ()=> {
        let self = this;
        let {limit,searchQuery,loopSize,loopIndex} = this.state;
        if(loopSize >= ++loopIndex){
            console.log("loopSize::",loopSize);
            console.log("loopIndex::",loopIndex);
            self.setState({loopIndex});
            let params = {
                url: `/connector/readDocument/${self.props.type}/&${searchQuery}/${limit}`,
                method: "post"
            };
            self.setState({searching:true, confirmBtnDisabled:false});
            try{
                let {data} = await request(params);
                self.send(data,"READ_DOCUMENT");

            }catch(error){
                let err = {response:{data:"Bağlantı Hatası"}}
                showAxiosError(err);
                self.setState({outboxList:[],searching:false});
            }
        }
    }

    onCancel = () => {
        if(this._source)
            this._source.cancel();

        this.props.toggleModal(false,false);
        this.state.ws.close();
        if(this.state.interval) {
            clearInterval(this.state.interval);
            this.setState({interval: null});
        }
    }

    listenWebSocket = async (ip) =>{
        let self = this;
        ip= ip + "/websocket/chat";
        const ws = new WebSocket(ip);
        this.setState({ws});

        ws.onopen = () => {
            console.log("onopen");
            this.setState({connected:true});
        }

        // listen to data sent from the websocket server
        ws.onmessage = evt => {
            console.log("onmessage");
            let {queryType,rows,uuid} = JSON.parse(evt.data)
            if(queryType !== 'UPDATE_TMP_INVOICE')
                this.setState({retry:false});

            rows = JSON.parse(rows);
            if(queryType === "ERROR" && rows){
                let message = "";
                if(rows instanceof Array){
                    console.log(rows[0].error);
                    message=rows[0].error;
                }else{
                    if(rows.error && rows.error instanceof Array){
                        console.log(rows.error[0]);
                        message=rows.error[0];
                    }
                }
                Alert.error(message ? message : "ERP tarafındaki konnektörün açık olduğundan emin olunuz!", {
                    position: 'bottom-right',
                    effect: 'stackslide',
                    timeout: 7000
                });
                this.setState({searching:false});
            } else if((queryType === "INVOICE_LENGTH") && rows != null){
                const {limit} = this.state;
                let totalLength = rows[0].Column1;
                let loopSize= Math.ceil(totalLength/limit);
                self.setState({totalLength, loopSize, loopIndex:0, outboxList:[]});
                if(loopSize === 0){
                    self.setState({searching:false}, ()=>{
                        Alert.success("Arama kriterlerine uygun fatura bulunamadı.", {
                            position: 'bottom-right',
                            effect: 'stackslide',
                            timeout: 7000
                        });
                    });
                    return;
                }else{
                    self.handleSearch();
                }
            }else if((queryType === "READ_DOCUMENT") && rows != null ) {
                if (rows.length === 0) {
                    Alert.success("Arama kriterlerine uygun fatura bulunamadı.", {
                        position: 'bottom-right',
                        effect: 'stackslide',
                        timeout: 7000
                    });
                }
                if(rows && rows.length>0) {
                    rows = rows.map(row => {
                        if (!row.documentUuid) {
                            row.documentUuid = uuidGenerator();
                        }
                        return row;
                    })
                }
                self.setState({outboxList: rows, searching:false}, ()=>{
                    if(rows.length>0 && (self.state.saveClicked || self.state.continueSend)){
                        self.confirm();
                    }
                });
            }else if ((queryType === "READ_INVOICE_DESPATCH") && rows != null ){
              let {outboxList} = self.state;
              let Index = outboxList.findIndex(x => x.documentUuid === uuid);
              let outbox = outboxList[Index];
              if (rows.length>0){
                let referenceList = [];
                rows.map(row => {
                  referenceList.push({
                    referenceId:row.despatchRefId.trim(),
                    referenceIssueDate: row.despatchRefDate.trim()
                  })
                });
                outbox.trdDocInvoiceDespatchReferences=referenceList;
              }
              self.readInvoiceLineSql(deepCopyObject(outbox));
            }else if((queryType === "READ_DOCUMENT_LINE") && rows != null ) {
                let {outboxList} = self.state;
                let {type}=self.props;
                if(type === "despatch"){
                    let despatchIndex = outboxList.findIndex(x => x.documentUuid === uuid);
                    let outbox = outboxList[despatchIndex];
                    outbox.despatchLines = rows;
                    outbox.status = "processing";
                    outboxList[despatchIndex] = outbox;

                    let result = isValidERPOutboxPyld(outbox, despatchIndex);
                    let valid = result.valid;

                    if (valid) {
                        self.saveToTemp(outbox, despatchIndex);
                    } else {
                        self.setState({error: result.error, confirmBtnDisabled: false});
                        Alert.error(result.errorMessage, {
                            position: 'bottom-right',
                            effect: 'stackslide',
                            timeout: 7000
                        });
                    }
                    self.setState({confirmBtnDisabled: true, outboxList});
                }else if(type === "voucher"){
                    outboxList.map(outbox=>{
                        if(outbox.documentUuid === uuid){
                            outbox.trdDocVoucherLines = rows;
                            outbox.status = "processing";
                            let referenceIdList = [];
                            let invoiceTypeCode = outbox.invoiceTypeCode;
                            let lineReferenceId = "";
                            if(rows && rows[0] && rows[0].lineReferenceId){
                                lineReferenceId =  rows[0].lineReferenceId;
                            }
                            rows.forEach(invoiceLine=>{
                                referenceIdList.push(invoiceLine.referenceId)
                            })
                            self.readInvoiceLineChargeSql(lineReferenceId,referenceIdList,invoiceTypeCode,outbox.documentUuid)

                            return outbox;
                        }
                    })
                }else {
                    outboxList.map(outbox=>{
                        if(outbox.documentUuid === uuid){
                            outbox.trdDocInvoiceLines = rows;
                            outbox.status = "processing";
                            let referenceIdList = [];
                            let invoiceTypeCode = outbox.invoiceTypeCode;
                            let lineReferenceId = "";
                            if(rows && rows[0] && rows[0].lineReferenceId){
                                lineReferenceId =  rows[0].lineReferenceId;
                            }
                            rows.forEach(invoiceLine=>{
                                referenceIdList.push(invoiceLine.referenceId)
                            })
                            self.readInvoiceLineChargeSql(lineReferenceId,referenceIdList,invoiceTypeCode,outbox.documentUuid)

                            return outbox;
                        }
                    })
                }

            }else if((queryType === "READ_DOCUMENT_LINE_CHARGE") && rows != null && rows.length>0) {
                let {outboxList} = self.state;
                let {type}=self.props;
                let invoiceIndex  = outboxList.findIndex(x => x.documentUuid ===uuid);
                let invoice = outboxList[invoiceIndex];
                let lines= null;
                if(type === "voucher"){
                    let lines = invoice.trdDocVoucherLines;
                    for(let i = 0;i<lines.length;i++){
                        for(let j = 0; j< rows.length; j++){
                            if(lines[i].referenceId == rows[j].voucherItemLineId ){
                                let arr = [];
                                if(lines[i].trdDocVoucherLineCharges !=null && lines[i].trdDocVoucherLineCharges.length>0){
                                    arr = lines[i].trdDocVoucherLineCharges;
                                }
                                arr.push(rows[j]);
                                lines[i].trdDocVoucherLineCharges = arr;
                            }
                        }
                    }
                }else{
                    let lines = invoice.trdDocInvoiceLines;
                    for(let i = 0;i<lines.length;i++){
                        for(let j = 0; j< rows.length; j++){
                            if(lines[i].referenceId == rows[j].invoiceLineId){
                                let arr = [];
                                if(lines[i].trdDocInvoiceLineCharges !=null && lines[i].trdDocInvoiceLineCharges.length>0){
                                    arr = lines[i].trdDocInvoiceLineCharges;
                                }
                                arr.push(rows[j]);
                                lines[i].trdDocInvoiceLineCharges = arr;
                            }
                        }
                    }
                }

                let result = isValidERPOutboxPyld(invoice, invoiceIndex);
                let valid = result.valid;

                if (valid) {
                    self.saveToTemp(invoice, invoiceIndex);
                }else{
                    self.setState({error:result.error,confirmBtnDisabled:false});
                    Alert.error(result.errorMessage, {
                        position: 'bottom-right',
                        effect: 'stackslide',
                        timeout: 7000
                    });
                }
                outboxList[invoiceIndex].trdDocInvoiceLines = lines;
                self.setState({confirmBtnDisabled: true, outboxList});
            } else if ((queryType === "UPDATE_TMP_INVOICE") && rows != null && rows.length > 0) {
                let referenceId = rows[0].referenceId;
                if (referenceId != null) {
                    let params = {
                        url: `/connector/updateSqlHistory/tmpInvoice/${referenceId}`,
                        method: "post"
                    };
                    try{
                        let {data} = request(params);
                    }catch(error){
                        console.log("UPDATE_TMP_INVOICE::ERROR::",error)
                    }
                }
            }
            console.log(queryType, uuid);
        }

        ws.onclose = () => {
            console.log("onclose");
            this.setState({connected:false});
            self.listenWebSocket(self.props.connectionInfo.ownerIp)
        }
    }

    checkLoopSaved = (outboxList) =>{
        let first = outboxList.find(outbox => {
            return outbox.success !== true
        });
        return !first;
    }

    saveToTemp = async(document,invoiceIndex)=>{
        let self = this;
        let {outboxList} = self.state;
        let {type}=self.props;
        let  url = '';
        if(type === 'despatch') {
            document =  modifyDespatch(document)
            url= `/connector/saveDespatchToTempWs/`;
        }else if(type === 'voucher'){
            document =  modifyVoucher(document)
            url= `/connector/saveVoucherToTempWs/`
        }else if(type === 'invoice'){
            document =  modifyInvoice(document)
            url= `/connector/saveInvoiceToTempWs/`
        }
        let params = {
            url,
            method: "post",
            data:deepCopyObject(document)
        };
        try{
            const response = await request(params);
            console.log("invoiceIndex::",invoiceIndex);
            document.profileId = response.data;
            document.status = "success";
            document.success = true;
            outboxList[invoiceIndex] = document;
            self.setState({outboxList});
            let loopSaved = self.checkLoopSaved(outboxList);
            console.log("loopSaved::",loopSaved);
            if (loopSaved) {
                await self.handleSearch();
            }
            if(type === 'invoice' && checkUseTmpUpdateQuery(this.props.currentUser.vknTckn)){
                await self.updateTmpInvoiceSql(document);
            }
            if(type === 'despatch' && checkUseTmpUpdateQueryWithDespatch(this.props.currentUser.vknTckn)){
                await self.updateTmpDespatchSql(document);
            }
            console.log("invoiceIndex::",invoiceIndex)
            console.log("limit::",this.state.limit)
            console.log("loopSaved::",loopSaved)
            if((invoiceIndex+1 === this.state.limit || invoiceIndex+1 === outboxList.length)
                && !loopSaved){
                setTimeout(() => {
                    let flag = self.checkLoopSaved(outboxList);
                    if(!flag) {
                        console.log("checkLoopSaved::loopSaved",flag)
                        console.log("checkLoopSaved::invoiceIndex",invoiceIndex)
                        self.setState({
                            continueSend:true,
                            retry: true,
                            retryCount: 0,
                            invoiceIndex:0,
                            outboxList:[] },()=> self.documentInformation(self.state.searchQuery));
                    }
                }, 10000);
            }
        }catch (error){
            document.status = "error";
            outboxList[invoiceIndex] = document;
            self.setState({outboxList, confirmBtnDisabled: false});
            showAxiosError(error, "bottom-right");
            return;
        }
    }

    uuidGenerator = ()=> {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    send = (query,queryType,documentUuid) =>{
        this.setState({retry:true});
        console.log(queryType+"::send::"+documentUuid);
        const {connectionInfo,currentUser} = this.props;

        let header = {
            customerId: currentUser.customerId,
            dataSource: connectionInfo.dataSource,
            initialCatalog: connectionInfo.initialCatalog,
            dbUser: connectionInfo.dbUser,
            dbPassword: connectionInfo.dbPassword,
            key: connectionInfo.key,
            branchId: connectionInfo.branchId,
            clientType:"PORTAL"
        }
        let body = {
            uuid:documentUuid?documentUuid: uuidGenerator(),
            queryType: queryType,
            query: query
        };

        let ws = this.state.ws;
        let jsonMsg = JSON.stringify({header,body})
        ws.send(jsonMsg);
    }

    typeConverter = (type) =>{
        if(type==="despatch"){ return "İrsaliye"}
        else if(type==="voucher")  { return "Müstahsil" }
        else { return "Fatura" }
    }

    dateConverter = (date) => {
        var date = new Date(date);
        var yyyy = date.getFullYear();
        let mm = date.getMonth() +1;
        let dd = date.getDate();

        if (mm < 10) {
            mm = "0" + mm;
        }
        if (dd < 10) {
            dd = "0" + dd;
        }

        return `${yyyy}-${mm}-${dd}`;
    }

    differanceDate = (startDate, finishDate) => {
        let start = new Date(startDate);
        let finish = new Date(finishDate);
        start.setHours(0, 0, 0, 0);
        finish.setHours(0, 0, 0, 0);
        let difference = finish - start;
        if (difference >= 0) {
            let daysDifference = Math.ceil(difference / (1000*3600*24));
            return daysDifference;
        }
    }

    render() {

        let {type} = this.props;
        let {outboxList} = this.state;
        const trStyle = {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis"
        }

        const fields = [
            {
                label: `${this.typeConverter(type)} Numarası`,
                accessor: "documentId",
                type: "text",
                operator: "=",
            },
            {
                label: `${this.typeConverter(type)} Tarihi (Başlangıç)`,
                accessor: "minIssueDate",
                type: "date",
                operator: "=",
                initialValue: moment().subtract(7,'days').format('YYYY-MM-DD'),
                disableAccessibleDate: true
            },
            {
                label:  `${this.typeConverter(type)} Tarihi (Bitiş)`,
                accessor: "maxIssueDate",
                type: "date",
                operator: "=",
                initialValue: moment().format('YYYY-MM-DD'),
                disableAccessibleDate: true
            }
        ];

        return (
            <DefaultModal disabled={this.state.searching || this.state.confirmBtnDisabled || (this.state.outboxList && this.state.outboxList.length ===0)}
                          isOpen={this.props.modal}
                          size="xxl"
                          title={this.props.title || ""}
                          confirmBtnText="Taslağa Kaydet"
                          cancelBtnText="Kapat"
                          onConfirm={()=>this.confirm(true)}
                          onCancel={this.onCancel}
            >
                <div className="row satirBasi" style={{marginTop: 20}}>
                    <div className="col-sm-12" style={{zIndex:9999,padding: '1',maxHeight:'450px'}}>
                        <DetailedSearch fields={fields}
                                        loading={this.state.searching}
                                        onSearch={this.documentInformation}/>
                    </div>
                    <div className="col-sm-12" style={{paddingBottom: '20px',maxHeight:'500px', overflow:"auto"}}>
                        {this.state.searching &&
                            <ReactLoading type="spinningBubbles" style={{
                                width: "70px",
                                height: "70px",
                                margin: "20px auto 0 auto",
                                fill: "#888"
                            }}/>
                        }
                        {!this.state.searching && outboxList.length>0 &&
                            <table className="" style={{textAlign: 'center'}}>
                                <thead>
                                {type === "invoice" &&
                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                        <th width="8%">Fatura No</th>
                                        <th width="8%">Belge No</th>
                                        <th width="8%">Fatura Tipi</th>
                                        <th width="10%">Fatura ETTN</th>
                                        <th width="8%">Fatura Tarihi</th>
                                        <th width="8%">VKN/TCKN</th>
                                        <th width="22%">Unvan</th>
                                        <th width="8%">İl</th>
                                        <th width="9%">Vergiler Hariç Tutar</th>
                                        <th width="9%">Ödenecek Tutar</th>
                                        <th width="4%">Durumu</th>
                                    </tr>
                                }{type==="despatch" &&
                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                        <th width="8%">İrsaliye No</th>
                                        <th width="8%">Belge No</th>
                                        <th width="10%">İrsaliye Tipi</th>
                                        <th width="10%">İrsaliye ETTN</th>
                                        <th width="8%">İrsaliye Tarihi</th>
                                        <th width="8%">VKN/TCKN</th>
                                        <th width="11%">Unvan</th>
                                        <th width="5%">İl</th>
                                        <th width="5%">Posta Kodu</th>
                                        <th width="5%">Ödenecek Tutar</th>
                                        <th width="4%">Durumu</th>
                                    </tr>
                                }
                                {type==="voucher" &&
                                    <tr style={{backgroundColor: '#ebedf0'}}>
                                        <th width="8%">Müstahsil No</th>
                                        <th width="8%">Belge No</th>
                                        <th width="8%">Müstahsil Tipi</th>
                                        <th width="10%">Müstahsil ETTN</th>
                                        <th width="8%">Müstahsil Tarihi</th>
                                        <th width="8%">VKN/TCKN</th>
                                        <th width="22%">Unvan</th>
                                        <th width="8%">İl</th>
                                        <th width="9%">Vergiler Hariç Tutar</th>
                                        <th width="9%">Ödenecek Tutar</th>
                                        <th width="4%">Durumu</th>
                                    </tr>
                                }
                                </thead>
                                <tbody>
                                {this.state.outboxList.map((outbox, index) =>
                                    <tr key={index}>
                                        <td style={{fontWeight:'bold', fontSize:'12px', padding: "0px", margin: "0px", backgroundColor: "inherit"}}>
                                            <input
                                                id={'documentId_' + index }
                                                type="text"
                                                maxLength={16}
                                                className="form-control"
                                                value={outbox.documentId}
                                                disabled={this.state.confirmBtnDisabled || outbox.success}
                                                onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "documentId"
                                                }, index)}/>
                                        </td>
                                        <td style={{fontWeight:'bold', fontSize:'12px', padding: "0px", margin: "0px", backgroundColor: "inherit"}}>
                                            <input
                                                id={'documentNumber_' + index }
                                                type="text"
                                                maxLength={16}
                                                className="form-control"
                                                value={outbox.documentNumber}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <div style={{display:'inline'}}>
                                                {outbox.profileId}
                                            </div>
                                        </td>
                                        <td>
                                            <input
                                                id={'documentUuid_' + index }
                                                type="text"
                                                maxLength={255}
                                                className="form-control"
                                                value={outbox.documentUuid}
                                                disabled={true}
                                                onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "documentUuid"
                                                }, index)}/>
                                        </td>
                                        <td>
                                            {moment(outbox.issueDate).isValid() ? moment(outbox.issueDate).format("DD-MM-YYYY") : ''}
                                        </td>
                                        <td>
                                            <input
                                                id={'vknTckn_' + index }
                                                type="text"
                                                data-vlength="1,255"
                                                maxLength={255}
                                                disabled={this.state.confirmBtnDisabled || outbox.success}
                                                className="form-control"
                                                value={outbox.vknTckn}
                                                onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "vknTckn"
                                                }, index)}/>
                                        </td>
                                        <td>
                                            <input
                                                id={'title_' + index }
                                                type="text"
                                                style={trStyle}
                                                data-vlength="1,255"
                                                maxLength={255}
                                                className="form-control"
                                                value={outbox.title}
                                                disabled={true}
                                                onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "title"
                                                }, index)}/>
                                        </td>
                                        <td>
                                            <input
                                                id={'city_' + index }
                                                type="text"
                                                data-vlength="1,255"
                                                maxLength={255}
                                                className="form-control"
                                                value={outbox.city}
                                                disabled={true}
                                                onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "city"
                                                }, index)}/>
                                        </td>
                                        {type==="despatch" &&
                                            <td>
                                                <input
                                                    id={'postalZone_' + index }
                                                    type="text"
                                                    data-vlength="1,255"
                                                    maxLength={255}
                                                    className="form-control"
                                                    value={outbox.postalZone}
                                                    disabled={false}
                                                    onChange={(e) => this.onChange({
                                                        value: e.target.value,
                                                        name: "postalZone"
                                                    }, index)}/>
                                            </td>
                                        }
                                        {(type==="invoice" || type ==="voucher") &&
                                            <td>
                                                <NumberFormat id={'taxExclusiveAmount_' + index }
                                                              value={outbox.taxExclusiveAmount}
                                                              allowNegative={false}
                                                              isNumericString={true}
                                                              allowEmptyFormatting={false}
                                                              decimalScale={9}
                                                              thousandSeparator={'.'}
                                                              decimalSeparator={','}
                                                              displayType="input"
                                                              placeholder=""
                                                              disabled={true}
                                                              renderText={value => {
                                                                  value.replace(/\./g, ',')
                                                              }}
                                                              onValueChange={(e) => this.onChange({
                                                                  value: e.value,
                                                                  name: "taxExclusiveAmount"
                                                              }, index)}
                                                              className="form-control"/>
                                            </td>
                                        }
                                        <td>
                                            <NumberFormat id={'payableAmount_' + index }
                                                          value={outbox.payableAmount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          placeholder=""
                                                          disabled={true}
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "payableAmount"
                                                          }, index)}
                                                          className="form-control"/>
                                        </td>
                                        <td>
                                            <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                {this.getStatusRender(outbox.status)}
                                                {outbox.error &&
                                                    <div>
                                                        <i className="fa fa-question-circle" id={"errorInfo" + index} style={{paddingLeft: '3px'}} aria-hidden="true"/>
                                                        <UncontrolledTooltip placement="right" target={"errorInfo" + index} delay={0} style={{whiteSpace: "pre-line"}}>
                                                            {outbox.error}
                                                        </UncontrolledTooltip>
                                                    </div>
                                                }
                                            </div>

                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        }
                    </div>
                    <div className="col-sm-12" style={{display:"flex", justifyContent:"flex-end"}}>

                        <div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Durum: {this.getStatusRender(this.state.connected? "success":"processing")}</div>
                        <div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Gösterilen Kayıt Sayısı: {this.state.outboxList ? this.state.outboxList.length : 0}</div>
                        <div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Toplam Kayıt Sayısı: {this.state.totalLength ? this.state.totalLength : 0}</div>
                    </div>
                </div>
            </DefaultModal>
        )
    }
}

export default GetFromConnectorModalWs;